import { TableRow, TableCell, Typography } from '@mui/material';
import { AnyPlan } from './types';

type PlansHeaderRowProps = {
  plans: AnyPlan[];
  headerBg: string;
  firstColWidth?: number;
};

export default function PlansHeaderRow({
  plans,
  headerBg,
  firstColWidth = 243,
}: PlansHeaderRowProps) {
  return (
    <TableRow sx={{ height: '128px' }}>
      <TableCell
        sx={{
          width: firstColWidth,
          p: 2,
          bgcolor: headerBg,
          borderRight: '1px solid',
          borderBottom: 'none',
          borderColor: '#C7D8F9',
        }}
      />

      {plans.map((plan) => (
        <TableCell
          key={`header-${plan.id}`}
          sx={{
            p: 2,
            bgcolor: headerBg,
            borderLeft: '1px solid',
            borderColor: '#C7D8F9',
            verticalAlign: 'baseline',
            borderBottom: 'none',
          }}
        >
          <Typography
            fontWeight={600}
            fontSize="14px"
            color="#525F81"
            sx={{ wordBreak: 'break-word' }}
          >
            {plan.planName}
          </Typography>
        </TableCell>
      ))}
    </TableRow>
  );
}
